import { ArticleFieldsFragment } from '@src/generated/graphql';
import { useNavigate } from 'react-router-dom';


type BlogFeaturedProps = {
  content: ArticleFieldsFragment;
};

const BlogFeatured = ({ content }: BlogFeaturedProps) => {
  const { eyebrowText, publicationDate,title,author,thumbnailImage ,articleLink ,colour} =content
  const navigate = useNavigate()
  const formattedDate = new Date(publicationDate).toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
  

  return (
    <>
    <div className='first-blog'>
        <div className='blog-1 blog' 
         onClick={() => {
                    const linkUrl = articleLink?.linkUrl ?? "";
                    const normalizedUrl = linkUrl.startsWith("/") ? linkUrl : `/${linkUrl}`;
                    navigate(normalizedUrl);
                  }}
         >
              <img
                src={thumbnailImage?.url ?? ""}
                alt="background"
                className="background-image"
                style={{maxHeight:"600px"}}
                
              />
              <div className='blog-content'>
                <div className='blog-top'>
                  <p className='main-para'>{eyebrowText}</p>
                  <h3 className='bold'>{title}</h3>
                </div>
                  <div className='blog-user'>
                    <div className='blog-user-image'>
                      <img
                        src={author?.image?.url ?? ""}
                        alt="background"
                        className="blog-user-image"
                      />
                    </div>
                    <div className='blog-user-details'>
                        <h4 className='font-medium'>{author?.name}</h4>
                        <span style={{color:colour ?? ""}}>{formattedDate}</span>
                    </div>  
                  </div>
              </div>
          </div>
      </div>
    </>
   
  );
};

export default BlogFeatured;

